import { ShippingContextDataFn } from "../../instantAnswerDataFunctions/shippingContextDataFn";
import { MessageRetailerOrBrandButton } from "../../shared/instantAnswerUtils";
import { countryToISO } from "../../utils/countryToISO";
import { getShipFromCountryForOrder } from "../../utils/getShipFromCountryForOrder";
import { getShipFromCountryForBrand } from "../../utils/getShippingFromCountryForBrand";
import { isSWFAvailableInCountry } from "../../utils/isSWFAvailableInCountry";
export var HowShippingWorks = function HowShippingWorks(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _MessageRetailerOrBra;
        return (_MessageRetailerOrBra = MessageRetailerOrBrandButton(context, strictLocalize)) === null || _MessageRetailerOrBra === void 0 ? void 0 : _MessageRetailerOrBra.label;
      },
      onClickFunctionBuilder: function onClickFunctionBuilder(context) {
        var _MessageRetailerOrBra2;
        return (_MessageRetailerOrBra2 = MessageRetailerOrBrandButton(context, strictLocalize)) === null || _MessageRetailerOrBra2 === void 0 ? void 0 : _MessageRetailerOrBra2.onClick;
      }
    },
    additionalRequiredData: [ShippingContextDataFn]
  };
};
var getAnswer = function getAnswer(context, strictLocalize) {
  var _getShipFromCountryFo;
  var shipFromCountry = (_getShipFromCountryFo = getShipFromCountryForOrder(context)) !== null && _getShipFromCountryFo !== void 0 ? _getShipFromCountryFo : getShipFromCountryForBrand(context.brand);
  var shipFromCountryISO = countryToISO(shipFromCountry);
  return isSWFAvailableInCountry(shipFromCountryISO) ? SwfAvailableScenario(strictLocalize) : SwfNotAvailableScenario(strictLocalize);
};
var SwfAvailableScenario = function SwfAvailableScenario(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return SHIPPING_OPTIONS(strictLocalize);
    },
    getDescription: function getDescription() {
      return [OLD_YOU_CAN_CHOOSE_SHIPPING_TYPE(strictLocalize), OLD_SHIP_WITH_FAIRE_DEFINITION(strictLocalize), OLD_SHIP_ON_YOUR_OWN_DEFINITION(strictLocalize)];
    }
  };
};
var SwfNotAvailableScenario = function SwfNotAvailableScenario(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return SHIPPING_OPTIONS(strictLocalize);
    },
    getDescription: function getDescription() {
      return [YOU_CAN_USE_YOUR_OWN_CARRIER(strictLocalize)];
    }
  };
};
var SHIPPING_OPTIONS = function SHIPPING_OPTIONS(strictLocalize) {
  return strictLocalize({
    id: "UGEH5X",
    defaultMessage: [{
      "type": 0,
      "value": "Opções de envio"
    }]
  });
};
var OLD_YOU_CAN_CHOOSE_SHIPPING_TYPE = function OLD_YOU_CAN_CHOOSE_SHIPPING_TYPE(strictLocalize) {
  return strictLocalize({
    id: "cITe5h",
    defaultMessage: [{
      "type": 0,
      "value": "Quando estiver tudo pronto para enviar a sua encomenda, poderá optar pelo Envio com a Faire ou Enviar por conta própria."
    }]
  });
};
var YOU_CAN_USE_YOUR_OWN_CARRIER = function YOU_CAN_USE_YOUR_OWN_CARRIER(strictLocalize) {
  return strictLocalize({
    id: "ctr/F1",
    defaultMessage: [{
      "type": 0,
      "value": "Quando estiver tudo pronto para enviar a sua encomenda, pode usar uma transportadora da sua preferência para a enviar. Basta inserir o custo de envio e o número de seguimento no nosso sistema assim que estiver disponível e emitir-lhe-emos um reembolso dos custos de envio no pagamento total da sua encomenda."
    }]
  });
};
var OLD_SHIP_WITH_FAIRE_DEFINITION = function OLD_SHIP_WITH_FAIRE_DEFINITION(strictLocalize) {
  return strictLocalize({
    id: "pgJwpA",
    defaultMessage: [{
      "type": 0,
      "value": "A opção Enviar com a Faire permite-lhe imprimir as suas etiquetas de envio através da Faire para receber tarifas mais baixas da transportadora e não pagar despesas de envio. Iremos registar automaticamente o custo de envio e o número de seguimento da encomenda para ajudar a poupar tempo."
    }]
  });
};
var OLD_SHIP_ON_YOUR_OWN_DEFINITION = function OLD_SHIP_ON_YOUR_OWN_DEFINITION(strictLocalize) {
  return strictLocalize({
    id: "FAgUqw",
    defaultMessage: [{
      "type": 0,
      "value": "A opção Enviar por conta própria permite-lhe tratar do envio como entender. Pode usar uma transportadora da sua preferência para enviar esta encomenda. Basta inserir o custo de envio e o número de seguimento no nosso sistema assim que estiver disponível, e emitir-lhe-emos um reembolso dos custos de envio no pagamento total da sua encomenda."
    }]
  });
};